// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3zr4r","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3Wv1K"};